
export const pageTitlePatterns: {
    pattern: RegExp;
    getTitle: (pathname: string) => string;
}[] = [
  { pattern: /^\/$/, getTitle: () =>  'Inicio' },
  { pattern: /^\/dashboard$/, getTitle: () => 'Dashboard' },
  { pattern: /^\/clients$/, getTitle: () => 'Clientes' },
  { pattern: /^\/quotes$/, getTitle: () => 'Ofertas' },
  { 
    pattern: /^\/quotes\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/quotes\/(\d+)\/show$/)?.[1];
      return `Ver Oferta #${id}`;
    }
  },
  { 
    pattern: /^\/quotes\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/quotes\/(\d+)\/edit$/)?.[1];
      return `Modificar Oferta #${id}`;
    }
  },
  { pattern: /^\/pedidos$/, getTitle: () => 'Pedidos' },
  { 
    pattern: /^\/transportation-orders\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/transportation-orders\/(\d+)\/show$/)?.[1];
      return `Ver Pedido #${id}`;
    }
  },
  { 
    pattern: /^\/transportation-orders\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/transportation-orders\/(\d+)\/edit$/)?.[1];
      return `Editar Pedido #${id}`;
    }
  },
  { 
    pattern: /^\/dispatch-programs$/, 
    getTitle: () => 'Despachos' 
  },
  { 
    pattern: /^\/dispatch-programs\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/dispatch-programs\/(\d+)\/show$/)?.[1];
      return `Ver Despacho #${id}`;
    }
  },
  { 
    pattern: /^\/dispatch-programs\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/dispatch-programs\/(\d+)\/edit$/)?.[1];
      return `Editar Despacho #${id}`;
    }
  },

  { 
    pattern: /^\/payment-statuses$/, 
    getTitle: () => 'Estados de pago ' 
  },
  { 
    pattern: /^\/payment-statuses\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/payment-statuses\/(\d+)\/show$/)?.[1];
      return `Ver Estado de pago #${id}`;
    }
  },
  { 
    pattern: /^\/payment-statuses\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/payment-statuses\/(\d+)\/edit$/)?.[1];
      return `Editar Estado de pago #${id}`;
    }
  },

  { 
    pattern: /^\/tax-documents$/, 
    getTitle: () => 'Documentos de Venta ' 
  },
  { 
    pattern: /^\/tax-documents\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/tax-documents\/(\d+)\/show$/)?.[1];
      return `Ver Documento de Venta #${id}`;
    }
  },
  { 
    pattern: /^\/tax-documents\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/tax-documents\/(\d+)\/edit$/)?.[1];
      return `Editar Documento de Venta #${id}`;
    }
  },

  { 
    pattern: /^\/daily-carriers$/, 
    getTitle: () => 'Transportes' 
  },

  { 
    pattern: /^\/guides$/, 
    getTitle: () => 'Guías' 
  },

  { 
    pattern: /^\/purchase-orders$/, 
    getTitle: () => 'Ordenes de compra' 
  },
  { 
    pattern: /^\/purchase-orders\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/purchase-orders\/(\d+)\/show$/)?.[1];
      return `Ver Orden #${id}`;
    }
  },
  { 
    pattern: /^\/purchase-orders\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/purchase-orders\/(\d+)\/edit$/)?.[1];
      return `Editar Orden #${id}`;
    }
  },

  { 
    pattern: /^\/service-manifests$/, 
    getTitle: () => 'Hojas de Entrada' 
  },
  { 
    pattern: /^\/service-manifests\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/service-manifests\/(\d+)\/show$/)?.[1];
      return `Ver Hoja #${id}`;
    }
  },
  { 
    pattern: /^\/service-manifests\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/service-manifests\/(\d+)\/edit$/)?.[1];
      return `Editar Hoja #${id}`;
    }
  },

  { 
    pattern: /^\/providers$/, 
    getTitle: () => 'Proveedores' 
  },

  { 
    pattern: /^\/checking-accounts$/, 
    getTitle: () => 'Movimientos' 
  },

  { 
    pattern: /^\/internal-settlements$/, 
    getTitle: () => 'Cuentas' 
  },

  { 
    pattern: /^\/currencies$/, 
    getTitle: () => 'Monedas' 
  },
  { 
    pattern: /^\/currencies\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/currencies\/(\d+)\/edit$/)?.[1];
      return `Editar Moneda #${id}`;
    }
  },

  { 
    pattern: /^\/foreign-exchanges$/, 
    getTitle: () => 'Divisas' 
  },

  { 
    pattern: /^\/non-exchange-days$/, 
    getTitle: () => 'Días de no cambio' 
  },

  { 
    pattern: /^\/business-names$/, 
    getTitle: () => 'Razones Sociales' 
  },
  { 
    pattern: /^\/business-names\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/business-names\/(\d+)\/edit$/)?.[1];
      return `Editar Razón Social #${id}`;
    }
  },

  { 
    pattern: /^\/contact-types$/, 
    getTitle: () => 'Tipo de Contacto' 
  },

  { 
    pattern: /^\/cost-centers$/, 
    getTitle: () => 'Centros de Costos' 
  },

  { 
    pattern: /^\/users$/, 
    getTitle: () => 'Usuarios' 
  },

  { 
    pattern: /^\/places$/, 
    getTitle: () => 'Origenes y destinos' 
  },

  { 
    pattern: /^\/societies$/, 
    getTitle: () => 'Sociedades' 
  },

  { 
    pattern: /^\/societies-signatures$/, 
    getTitle: () => 'Firmas de Sociedad' 
  },

  { 
    pattern: /^\/products$/, 
    getTitle: () => 'Productos' 
  },

  { 
    pattern: /^\/units$/, 
    getTitle: () => 'Unidades' 
  },

  { 
    pattern: /^\/item-categories$/, 
    getTitle: () => 'Categorías' 
  },

  { 
    pattern: /^\/accounts$/, 
    getTitle: () => 'Cuentas Contables' 
  },

  { 
    pattern: /^\/clasifications$/, 
    getTitle: () => 'Clasificaciones' 
  },

  { 
    pattern: /^\/services$/, 
    getTitle: () => 'Servicios' 
  },

  { 
    pattern: /^\/incoterms$/, 
    getTitle: () => 'Condicion de Entrega' 
  },

  { 
    pattern: /^\/sectors$/, 
    getTitle: () => 'Sectores' 
  },

  { 
    pattern: /^\/packing-forms$/, 
    getTitle: () => 'Formas de Empaque' 
  },

  { 
    pattern: /^\/provider-types$/, 
    getTitle: () => 'Tipos de Proveedores' 
  },

  { 
    pattern: /^\/roles$/, 
    getTitle: () => 'Roles' 
  },

  { 
    pattern: /^\/taxes$/, 
    getTitle: () => 'Impuestos' 
  },

  { 
    pattern: /^\/carriers$/, 
    getTitle: () => 'Conductores' 
  },

  { 
    pattern: /^\/trucks$/, 
    getTitle: () => 'Camiones' 
  },

  { 
    pattern: /^\/hoppers$/, 
    getTitle: () => 'Tolvas' 
  },

  { 
    pattern: /^\/route-segments$/, 
    getTitle: () => 'Tramos' 
  },

  { 
    pattern: /^\/banks$/, 
    getTitle: () => 'Bancos' 
  },

  { 
    pattern: /^\/bank-account-reasons$/, 
    getTitle: () => 'Motivo de Cuenta' 
  },

  { 
    pattern: /^\/bank-account-types$/, 
    getTitle: () => 'Tipo de Cuentas Bancarias' 
  },

  { 
    pattern: /^\/batches$/, 
    getTitle: () => 'Lotes' 
  },
  { 
    pattern: /^\/batches\/\d+\/show$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/batches\/(\d+)\/show$/)?.[1];
      return `Ver Lote #${id}`;
    }
  },
  { 
    pattern: /^\/batches\/\d+\/edit$/, 
    getTitle: (pathname) => {
      const id = pathname.match(/^\/batches\/(\d+)\/edit$/)?.[1];
      return `Editar Lote #${id}`;
    }
  },

  { 
    pattern: /^\/batch-types$/, 
    getTitle: () => 'Tipos de Lotes' 
  },

  { 
    pattern: /^\/depots$/, 
    getTitle: () => 'Almacenes' 
  },

  { 
    pattern: /^\/brands$/, 
    getTitle: () => 'Marcas' 
  },

  { 
    pattern: /^\/centers$/, 
    getTitle: () => 'Centros' 
  },

  { 
    pattern: /^\/payment-methods$/, 
    getTitle: () => 'Formas de Pago' 
  },

  { 
    pattern: /^\/unit-conversions$/, 
    getTitle: () => 'Conversión de Unidades' 
  },

  { 
    pattern: /^\/cause-notes$/, 
    getTitle: () => 'Motivos de Notas' 
  },



  // Agrega más patrones según sea necesario
];